var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49992 1.77087C2.09721 1.77087 1.77075 2.09733 1.77075 2.50004V3.66671C1.77075 4.06942 2.09721 4.39587 2.49992 4.39587H9.49992C9.90263 4.39587 10.2291 4.06942 10.2291 3.66671V2.50004C10.2291 2.09733 9.90263 1.77087 9.49992 1.77087H2.49992ZM0.895752 2.50004C0.895752 1.61408 1.61396 0.895874 2.49992 0.895874H9.49992C10.3859 0.895874 11.1041 1.61408 11.1041 2.50004V3.66671C11.1041 4.55266 10.3859 5.27087 9.49992 5.27087H2.49992C1.61396 5.27087 0.895752 4.55266 0.895752 3.66671V2.50004Z",
    fill: "#A5AAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49992 7.60421C2.09721 7.60421 1.77075 7.93067 1.77075 8.33337V9.50004C1.77075 9.90275 2.09721 10.2292 2.49992 10.2292H9.49992C9.90263 10.2292 10.2291 9.90275 10.2291 9.50004V8.33337C10.2291 7.93067 9.90263 7.60421 9.49992 7.60421H2.49992ZM0.895752 8.33337C0.895752 7.44742 1.61396 6.72921 2.49992 6.72921H9.49992C10.3859 6.72921 11.1041 7.44742 11.1041 8.33337V9.50004C11.1041 10.386 10.3859 11.1042 9.49992 11.1042H2.49992C1.61396 11.1042 0.895752 10.386 0.895752 9.50004V8.33337Z",
    fill: "#A5AAB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClm);
export default __webpack_public_path__ + "static/media/clm.b7f6bf32382d605e07d9f325609e73b9.svg";
export { ForwardRef as ReactComponent };